import React from "react";

export default function Modal({ content, setShowModal }) {
  return (
    <div
      _ngcontent-ng-c1546520345=""
      id="exampleModal1"
      tabIndex={-1}
      style={{ display: "block" }}
      role="dialog"
      aria-labelledby="exampleModalLable"
      aria-hidden="true"
      className="modal fade show"
    >
      <div
        _ngcontent-ng-c1546520345=""
        role="document"
        className="modal-dialog modal-md"
      >
        <div _ngcontent-ng-c1546520345="" className="modal-content">
          <div
            _ngcontent-ng-c1546520345=""
            className="modal-content rules-wrap"
          >
            <div _ngcontent-ng-c1546520345="" className="rules-content">
              <div _ngcontent-ng-c1546520345="">{content}</div>
            </div>
            <ul _ngcontent-ng-c1546520345="" className="btn-wrap break">
              <li _ngcontent-ng-c1546520345="" style={{ listStyle: "none" }}>
                <a
                  _ngcontent-ng-c1546520345=""
                  data-bs-dismiss="modal"
                  className="btnok"
                  onClick={() => setShowModal(false)}
                >
                  OK
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
